<!-- Preserve 9px vertical spacing for wrapped Knots (SBUX-421). -->
<div class="flex flex-row items-center gap-4 px-8 min-h-[40px] w-full bg-[#F5F6FA]"
     [ngClass]="{ 'py-[9px]': shouldShowKnots(), 'py-4': !shouldShowKnots() }">
  <div class="text-variant-md text-[13px] tracking-[0.32px] flex items-center flex-wrap gap-4 text-text">

    <!-- Default Disabled State -->
    @if (shouldShowDisabledState()) {
      <div class="flex items-center gap-[7px]">
        <app-icon
          class="outbound-knots-control__knots-icon"
          name="sapphire-info"
          stchPopover
          [stchPopoverTemplate]="helpTpl"
          stchPopoverTrigger="hover"
          stchPopoverPlacement="bottom"
          [stchPopoverArrow]="true"/>
        <span class="text-blue-600">Enable Knots to send key topics from this message to your recipients</span>
      </div>
    }

    <!-- Default Enabled State -->
    @if (shouldShowEnabledNoKnotsState()) {
      <div class="flex items-center gap-[7px]">
        <app-icon
          class="outbound-knots-control__knots-icon"
          name="sapphire-info"
          stchPopover
          [stchPopoverTemplate]="helpTpl"
          stchPopoverTrigger="hover"
          stchPopoverPlacement="bottom"
          [stchPopoverArrow]="true"/>
        <span class="text-blue-600">Knots will appear at the beginning of your message</span>
      </div>
    }

    <!-- Enabled and No Valid Knots -->
    @if (shouldShowNoValidKnots()) {
      <span>No valid knots.</span>
    }

    <!-- Enabled and Processing -->
    @if (shouldShowKnotsProcessingState()) {
      <span class="text-blue-600">Processing Knots...</span>
    }

    <!-- Knots State -->
    @if (shouldShowKnots()) {
      <span class="text-variant-sm-medium"> Knots: </span>
      @for (knot of knots(); track knot.id) {
        <app-knot
          [dragEnabled]="false"
          [withRemove]="true"
          [withControls]="false"
          (onRemove)="unLinkKnot(knot)"
          [knot]="knot"/>
      }
    }
  </div>

  <span class="flex-grow"></span>

  <div class="flex flex-row items-start gap-8 max-w-[240px]">
    @if (isKnotsEnabled()) {
      <app-button2
        class="mt-px [&>button]:bg-background"
        [ngClass]="{
            'w-[97px]': previewTimeout()
          }"
        appearance="secondary"
        size="s"
        [disabled]="isPreviewDisabled()"
        (click)="onPreviewClick()">{{ previewBtnLabel() }}
      </app-button2>
    }
    <app-toggle-switch2
      class="pt-[1px]"
      appearance="primary"
      size="s"
      [appTooltip]="isKnotsEnabled() ? 'Disable Knots' : 'Enable Knots'"
      [formControl]="inputFormControl()"/>
  </div>
</div>

<!-- Popover templates -->
<ng-template #helpTpl>
  <div class="max-w-xs text-sm leading-snug p-7 w-162">
    Knots highlight key points, giving your receivers a quick snapshot of what an email is about—especially helpful
    for long messages.
  </div>
</ng-template>
